import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import '@/App.css';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import ExploreProjects from '@/pages/ExploreProjects';
import ProjectDetail from '@/pages/ProjectDetail';
import SubmitIdea from '@/pages/SubmitIdea';
import JoinCommunity from '@/pages/JoinCommunity';
import Contact from '@/pages/Contact';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/components/admin/AdminLayout';
import ProtectedRoute from '@/components/admin/ProtectedRoute';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import ProblemStatements from '@/pages/admin/ProblemStatements';
import Projects from '@/pages/admin/Projects';
import Applications from '@/pages/admin/Applications';
import ProjectLeaders from '@/pages/admin/ProjectLeaders';
import ReviewApprovals from '@/pages/admin/ReviewApprovals';
import Scheduling from '@/pages/admin/Scheduling';
import Integrations from '@/pages/admin/Integrations';
import Analytics from '@/pages/admin/Analytics';
import Users from '@/pages/admin/Users';
import { ThemeProvider } from '@/context/ThemeContext';

function LayoutWrapper({ children }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <>
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/explore" element={<ExploreProjects />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/submit-idea" element={<SubmitIdea />} />
        <Route path="/community" element={<JoinCommunity />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="problem-statements" element={<ProblemStatements />} />
          <Route path="projects" element={<Projects />} />
          <Route path="applications" element={<Applications />} />
          <Route path="project-leaders" element={<ProjectLeaders />} />
          <Route path="review-approvals" element={<ReviewApprovals />} />
          <Route path="scheduling" element={<Scheduling />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="users" element={<Users />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <LayoutWrapper>
            <AppRoutes />
          </LayoutWrapper>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
